export default "__VITE_ASSET__B7HEi61D__"